<template>
  <van-popup
    class="article-reply"
    :value="value" @input="$emit('input',$event)"
    position="right"
    @open="open()"
  >
    <van-nav-bar
      left-arrow
      @click-left="$emit('input',false)"
      :title="`${item.reply_count}条回复`"
    ></van-nav-bar>
    <div class="item2 van-hairline--bottom">
      <van-image
        round
        width="0.9rem"
        height="0.9rem"
        fit="fill"
        :src="item.aut_photo"
      />
      <div class="info">
        <p>
          <span class="name">{{ item.aut_name }}</span>
          <span class="follow" @click="handlerFollow(item)" :class="{ active: item.is_followed }">{{ item.is_followed ? "已关注" : "关注" }}</span>
        </p>
        <p class="content">{{ item.content }}</p>
        <p>
          <span class="time">{{ item.pubdate | relTime }}</span>
          <span class="zan" @click="toggleLike(item)">
            <span class="count">{{ item.like_count }}</span>
            <tt-icon :name="item.is_liking?'like-sel':'like'" />
          </span>
        </p>
      </div>
    </div>
    <div class="reply" style="flex:1">
      <p class="tit">全部回复</p>
      <div class="none" v-if="list.length===0 && !loading">
        <img width="160px" height="160px" src="@/assets/none.png" alt="">
        <p>还没有人评论哦</p>
      </div>
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
        :immediate-check="false"
      >
        <div
          class="item"
          v-for="item in list"
          :key="item.com_id.toString()"
        >
          <van-image
            round
            width="0.9rem"
            height="0.9rem"
            fit="fill"
            :src="item.aut_photo"
          />
          <div class="info">
            <p>
              <span class="name">{{ item.aut_name }}</span>
              <span class="zan" @click="toggleLike(item)">
                <span class="count">{{ item.like_count }}</span>
                <tt-icon :name="item.is_liking?'like-sel':'like'" />
              </span>
            </p>
            <p class="content">{{ item.content }}</p>
          </div>
        </div>
      </van-list>
    </div>
    <div class="artile-footer van-hairline--top">
      <van-field @click="showInput=true" readonly :border="false" left-icon="edit" :placeholder="item.reply_count?'写回复...':'抢沙发...'" />
      <tt-icon name="collect"><span>收藏</span></tt-icon>
      <tt-icon name="share"><span>分享</span></tt-icon>
    </div>
    <ArticleInput @submit="submitCommit"  title="回复评论" :placeholder="'@'+item.aut_name+'：'" v-model="showInput" />
  </van-popup>
</template>
<script>
import { commentOrReply, getCommentsOrReplys } from '@/api/article'
import { unCommentLikings, commentLikings } from '@/api/comment'
import ArticleInput from './article-input'
import { followMixin } from './mixins'
export default {
  name: 'articleReply',
  mixins: [followMixin],
  components: { ArticleInput },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    article: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      offset: null,
      // -----
      showInput: false,
      currReply: {}
    }
  },
  methods: {
    toggleLike (item) {
      (item.is_liking
        ? unCommentLikings(item.com_id)
        : commentLikings(item.com_id)).then(data => {
        item.is_liking = !item.is_liking
        item.like_count += item.is_liking ? 1 : -1
      })
    },
    async submitCommit (text) {
      this.$toast.loading()
      const data = await commentOrReply(this.item.com_id, text, this.article.art_id)
      this.list.unshift(data.new_obj)
      this.article.comm_count++
      this.item.reply_count++
      this.$toast.success('回复成功')
      this.showInput = false
    },
    handlerShowInput (item) {
      this.currReply = item
      this.showInput = true
    },
    open () {
      this.list = []
      this.loading = true
      this.finished = false
      this.offset = null
      this.onLoad()
    },
    async onLoad () {
      this.loading = true
      const data = await getCommentsOrReplys({
        type: 'c',
        source: this.item.com_id.toString(),
        offset: this.offset
      })
      this.list.push(...data.results)
      // 结束加载状态
      this.loading = false
      // 判断是否有数据
      if (data.last_id > data.end_id) {
        this.offset = data.last_id
      } else {
        this.finished = true
      }
    }
  }
}
</script>
<style scoped lang="less">
.artile-footer {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  padding-left: 10px;
  > .van-field {
    flex: 1;
    background: #F7F8FA;
    height: 32px;
    border-radius: 16px;
    padding: 0 10px;
    line-height: 32px;
    ::v-deep .van-field__left-icon .van-icon {
      color: #ccc;
    }
  }
  .tt-icon {
    text-align: center;
    font-size: 20px;
    margin: 0 12px;
    > span {
      font-size: 10px;
      display: block;
    }
  }
}
.article-reply {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .item2 {
    display: flex;
    padding: 10px 16px;
    height: 107px;
    .info {
      flex: 1;
      padding-left: 10px;
      width: 100%;
      overflow: hidden;
      p {
        padding: 5px 0;
        margin: 0;
        display: flex;
        justify-content: space-between;
      }
      .name {
        font-size: 15px;
      }
      .follow {
        font-size: 15px;
        color: @ttColor;
        .active {
          color: #ccc;
        }
      }
      .zan {
        display: flex;
        align-items: center;
        font-size: 14px;
        .count {
          margin-right: 10px;
        }
      }
      .content {
        color: #666;
        font-size: 16px;
        word-break: break-all;
      }
      .reply {
        width: 60px;
        height: 25px;
        background: #F7F8FA;
        border-radius: 12px;
        display: inline-block;
        line-height: 25px;
        text-align: center;
        font-size: 12px;
        .van-icon {
          position: relative;
          top: 2px;
        }
      }
      .time {
        color: #999;
        font-size: 14px;
      }
    }
  }
  .tit {
    background: #fff;
    padding: 16px;
    font-size: 16px;
  }
  .none {
    line-height: 1;
    padding: 10px 0;
    text-align: center;
    p {
      padding-top: 10px;
      color: #969799;
    }
  }
  .item {
  display: flex;
  padding: 10px 16px;
  .info {
    flex: 1;
    padding-left: 10px;
    width: 100%;
    overflow: hidden;
    p {
      padding: 5px 0;
      margin: 0;
    }
    .name {
      font-size: 15px;
    }
    .zan {
      float: right;
      display: flex;
      align-items: center;
      font-size: 14px;
      .count {
        margin-right: 10px;
        position: relative;
        top: 1px;
      }
    }
    .content {
      color: #666;
      font-size: 16px;
      word-break: break-all;
    }
    .reply {
      width: 60px;
      height: 25px;
      background: #F7F8FA;
      border-radius: 12px;
      display: inline-block;
      line-height: 25px;
      text-align: center;
      font-size: 12px;
      .van-icon {
        position: relative;
        top: 2px;
      }
    }
    .time {
      color: #999;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  }
}
</style>
